import React, { useEffect, useState } from "react";
import { useForm,  Controller } from "react-hook-form";
import { Row, Col, Container } from "reactstrap";
import { SearchableSelectHookForm } from "../../layout/HookFormInputs";
import { apiErrors,  notify, userDetails } from "../../../helper";
import { Drawer } from "@material-ui/core";
import LoaderCustom from "../../common/LoaderCustom";
import { API } from "../../../config/constants";
import axiosHelper from "../../../axiosHelper";
import { cloneDeep } from "lodash";

const userDetail = userDetails();

const AddAccountGroupMaster = (props) => {
    const Id = props?.open?.id;
    const formController = useForm({
        mode: "onChange",
        reValidateMode: "onChange"
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control,
    } = formController;
    const [loading, setLoading] = useState(false); // Loading state
    const [loader, setloader] = useState(false);
    const [MSMEList, setMSMEList] = useState([])
    const [accountGroupMasterList, setAccountGroupMasterList] = useState([])
    const [reconciliationAccountMasterList, setReconciliationAccountMasterList] = useState([]);

    useEffect(() => {
        if (props.accountGroupOnAction) {
            resetAccountGroupMasterForm(props.accountGroupOnAction)
        }
    }, [props.accountGroupOnAction])


    const resetAccountGroupMasterForm = (data = null) => {

        if (data) {
            reset({
                AccountGroupId: {
                    label: data?.AccountGroup,
                    value: data?.AccountGroupId
                },
                MsmeId: {
                    label: data?.MSME,
                    value: data?.MSMEId
                },
                ReconciliationAccountId: {
                    label: data?.ReconciliationAccount,
                    value: data?.ReconciliationAccountId
                }
            });
        } else {
            reset({
                AccountGroupId: null,
                MsmeId: null,
                ReconciliationAccountId: null
            });
        }
    }

    const cancelDrawer = () => {
        props.closeDrawer();
        resetAccountGroupMasterForm();
        props.setAccountGroupOnAction(null);
    };

    useEffect(() => {
        getMSMEList()
        getAccountGroupMasterList()
        getReconciliationAccountMasterList()

    }, [])


    const getMSMEList = () => {
        axiosHelper.get(`${API.getMSMEListForAccountGroup}`).then((response) => {
            if (response.data.IsSuccessful) {
                let list = response?.data?.Data?.map(el => ({ label: el.Name, value: el.Id }));
                setMSMEList(list)
            }
        })
            .catch((error) => {
                if (error.response.status === 401) {
                    apiErrors(error)
                }else{

                    throw error; // Re-throw the error to the caller
                }
            });
    }

    const getAccountGroupMasterList = () => {
        axiosHelper.get(`${API.getAccountGroupMasterList}`).then((response) => {
            if (response.data.IsSuccessful) {
                let list = response?.data?.Data?.AccountGroupMasterList?.map(el => ({ label: el.Name, value: el.Id }));
                setAccountGroupMasterList(list)
            }
        })
            .catch((error) => {
                if (error.response.status === 401) {
                    apiErrors(error)
                }else{

                    throw error; // Re-throw the error to the caller
                }
            });
    }

    const getReconciliationAccountMasterList = () => {
        axiosHelper.get(`${API.getReconciliationAccountMasterList}`).then((response) => {
            if (response.data.IsSuccessful) {
                let list = response?.data?.Data?.ReconciliationAccountMasterList?.map(el => ({ label: el.Name, value: el.Id }));
                setReconciliationAccountMasterList(list)
            }
        })
            .catch((error) => {
                if (error.response.status === 401) {
                    apiErrors(error)
                }else{

                    throw error; // Re-throw the error to the caller
                }
            });
    }

    const onSubmitAccountGroupMaster = (values) => {
        setloader(true)
        let payload = cloneDeep(values);
        payload.AccountGroupId = values?.AccountGroupId.value;
        payload.MsmeId = values?.MsmeId.value;
        payload.ReconciliationAccountId = values?.ReconciliationAccountId.value;
        payload.EmployeeId = parseInt(userDetail?.EmployeeId);
        //Append record Id during edit
        if (props.accountGroupOnAction?.Id) {
            payload.Id = props.accountGroupOnAction?.Id;
        }

        axiosHelper.post(`${API.addAndUpdateAccountGroupMaster}`, payload).then((response) => {
            props.getAllAccountGroupMaster();
            props.setOpen(false);
            setloader(false);
            resetAccountGroupMasterForm();
            if (response.data.IsSuccessful) {
                notify.success(response?.data?.Data?.Message);
                props.toggleKys1FormTabs("2")
                setloader(false);
            }
        })
            .catch((error) => {
                setloader(false);
                if (error.response.status === 401) {
                    apiErrors(error)
                }else{
                    if (!error?.response?.data?.IsSuccessful) {
                        notify.error(error?.response?.data?.ErrorMessage)
                    }
                }
                
            });
    };
    return (
        <>
            {loader && <LoaderCustom customClass="simulation-Loader" />}
            <div className="bg-white hl-common-page">
                <Drawer
                    // anchor={props.anchor}
                    open={props.open}
                    // onClose={(e) => toggleDrawer(e)}
                    anchor={"right"}
                >
                    <Container>
                        <div className={"drawer-wrapper"}>
                            <Row className="drawer-heading">
                                <Col>
                                    <div className={"header-wrapper left"}>
                                        <h3>{Id ? "Update Account Group Master" : "New Account Group Master"}</h3>
                                    </div>
                                    <div onClick={cancelDrawer} className={"close-button right"}></div>
                                </Col>
                            </Row>
                            <div>
                                {loading && <LoaderCustom />}
                                <form onSubmit={handleSubmit(onSubmitAccountGroupMaster)}>
                                    <Row className="part-detail-wrapper pl-3 pr-3 mt-3 flex-column">
                                        <Col md="12">
                                            <SearchableSelectHookForm
                                                label="Account Group"
                                                name="AccountGroupId"
                                                register={register}
                                                placeholder="Select"
                                                Controller={Controller}
                                                control={control}
                                                rules={{ required: true }}
                                                options={accountGroupMasterList}
                                                mandatory={true}
                                                handleChange={() => { }}
                                                errors={errors?.AccountGroupId}
                                                disabled={false}
                                            />
                                        </Col>
                                        <Col md="12">
                                            <SearchableSelectHookForm
                                                label="MSME"
                                                name="MsmeId"
                                                register={register}
                                                placeholder="Select"
                                                Controller={Controller}
                                                control={control}
                                                rules={{ required: true }}
                                                options={MSMEList}
                                                mandatory={true}
                                                handleChange={() => { }}
                                                errors={errors?.MsmeId}
                                                disabled={false}
                                            />
                                        </Col>
                                        <Col md="12">
                                            <SearchableSelectHookForm
                                                label="Reconciliation Account"
                                                name="ReconciliationAccountId"
                                                register={register}
                                                placeholder="Select"
                                                Controller={Controller}
                                                control={control}
                                                rules={{ required: true }}
                                                options={reconciliationAccountMasterList}
                                                mandatory={true}
                                                handleChange={() => { }}
                                                errors={errors?.ReconciliationAccountId}
                                                disabled={false}
                                            />
                                        </Col>
                                        <Col md="12" className="justify-content-end d-flex hl-switch-btn">
                                            <div className="text-right">
                                                <button
                                                    type={"button"}
                                                    className="reset mr15 cancel-btn"
                                                    onClick={cancelDrawer}
                                                >
                                                    <div className={"cancel-icon"}></div>
                                                    {"Cancel"}
                                                </button>
                                                <button type="submit" className="submit-button save-btn" >
                                                    <div class="save-icon"></div> {Id ? "Update" : "Save"}
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </div>
                        </div>
                    </Container>
                </Drawer>
            </div>
        </>
    );
};

export default AddAccountGroupMaster;
